export default __webpack_public_path__ + "static/media/advanced-filter-group-closed.73766bd4.svg";